var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "flex justify-center px-0 h-min-content",
      staticStyle: { "max-width": "420px" },
      attrs: { cols: "12" },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "w-full soli-round",
          class: {
            "mx-3": _vm.$vuetify.breakpoint.smAndUp,
            "mx-auto": _vm.$vuetify.breakpoint.xs,
            //'outline-selection': recommended,
            //'soli-round': $vuetify.breakpoint.smAndUp,
          },
          attrs: {
            "max-width": _vm.width,
            light: "",
            elevation:
              _vm.$vuetify.breakpoint.smAndUp && _vm.recommended ? 6 : 0,
          },
        },
        [
          _c(
            "v-container",
            {
              staticClass: "flex flex-col founders-card-min-height",
              class: { "founders-card-selected": _vm.recommended },
            },
            [
              _vm.recommended
                ? _c(
                    "div",
                    {
                      staticClass:
                        "flex justify-center text-title font-weight-bold soli-grey align-center pt-2",
                    },
                    [
                      _c(
                        "v-icon",
                        { attrs: { large: "", left: "", color: "accent" } },
                        [_vm._v("verified")]
                      ),
                      _vm._v("Recommended for you\n            "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex justify-center pa-2 pb-0 align-center gap-4",
                },
                [
                  _c(
                    "v-avatar",
                    { attrs: { size: "96" } },
                    [_c("v-img", { attrs: { src: _vm.image } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex px-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex flex-col justify-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "accent--text uppercase flex flex-col",
                            staticStyle: { "line-height": "22px" },
                          },
                          [
                            _c("div", { staticClass: "text-sm" }, [
                              _vm._v(_vm._s(_vm.heading)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "font-weight-bold contents",
                                class: { "text-2xl": _vm.title.length < 10 },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.title) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "soli-grey caption",
                            staticStyle: { "line-height": "1rem" },
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.subtitle) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass: "mt-1",
                            attrs: {
                              text: "",
                              "x-small": "",
                              rounded: "",
                              outlined: "",
                              color: "primary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("learnMore", _vm.membership)
                              },
                            },
                          },
                          [_vm._v("Learn More")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "px-2 flex flex-col flex-grow-1" },
                [
                  _c("FoundersClubCardPrices", {
                    attrs: {
                      membership: _vm.membership,
                      button2: _vm.button2,
                      selected: _vm.selected,
                    },
                    on: {
                      input: function ($event) {
                        _vm.selected = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "description-content soli-grey py-2",
                    domProps: { innerHTML: _vm._s(_vm.description) },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "flex flex-col gap-2 pb-0 flex-grow-0" },
                [
                  _c(
                    "SoliBtn",
                    {
                      class: { "mb-2": !_vm.button2 },
                      attrs: {
                        block: "",
                        gradient: "gradient-orange",
                        large: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("input", _vm.selected)
                        },
                      },
                    },
                    [_vm._v("\n                    " + _vm._s(_vm.button1))]
                  ),
                  _vm._v(" "),
                  _vm.button2
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            block: "",
                            text: "",
                            rounded: "",
                            color: "dark",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("input", false)
                            },
                          },
                        },
                        [_vm._v("\n                    " + _vm._s(_vm.button2))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }